import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Brand } from '../../../../../../../projects/Administration/src/app/business-entities/brand.model';
import { RentalCarService } from '../../../../../../../projects/Administration/src/app/business-services/rental-car.service';
import { ImageService } from '../../../../../../../projects/Administration/src/app/services/image.service';
import { CurrentLanguage } from '../../../../../../../projects/Autofacets-Core/src/app/common-services/current-language.service';
import { UserDataService } from '../../../../../../../src/app/DataServices/user-data.service';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { VehicleType } from '../../../business-entities/vehicle-list-view-model'
import { Constant } from '../../../../../../../projects/Autofacets-Core/src/app/utils/constant';
import { CheckListBusinessService } from '../../../../../../../projects/Administration/src/app/business-services/check-list.service';

import { AddPreferenceModel } from '../../../business-entities/preferences-model';
import { PreferenceBusinessService } from '../../../business-services/preference.service';

@Component({
  selector: 'app-add-preferences',
  templateUrl: './add-preferences.component.html',
  styleUrls: ['./add-preferences.component.css']
})
export class AddPreferencesComponent implements OnInit {

  preference: AddPreferenceModel =
    {
      brandId: null,
      question: "",
      questionDescription: "",
      enquestionDescription: "",
      dequestionDescription: "",
      nlquestionDescription: "",
      answerInputs: "",
      createdBy: "",
      imageBinaryData: "",
      mimeType: "",
      image: "",
      preferenceImage: "",
      languageCode: '',
      id: 0
    };
  isMaxAnswer: boolean = false
  answers: string
  addPreference = false;
  AnswerList = Array(1);
  addPreferencesForm: FormGroup;
  brandList: Brand[] = [];
  brand: Brand[];
  imageBaseData: string | ArrayBuffer = null;
  allLanguage: any[];

  vehicleTypes: VehicleType[] = [];
  constructor(
    private formBuilder: FormBuilder,
    private getAllBrandData: RentalCarService,
    private preferenceService: PreferenceBusinessService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private activeModal: NgbActiveModal,
    private userService: UserDataService,
    private imageService: ImageService,
    private checkListService: CheckListBusinessService
  ) { }

  ngOnInit(): void {
    this.allLanguage = this.currentLanguageService.LanguageList;
    this.addPreferencesForm = this.formBuilder.group({
      brand: [null, [Validators.required]],
      question: new FormArray([]),
      questionDescription: new FormArray([]),
      //answerInputs: ['', [Validators.required]],
      answers: this.formBuilder.array([
        new FormControl('Yes'),
      ]),
      image: [''],
      isActive: [true]
    });
    this.getBrandData();
    this.getLanguage();
    this.GetAllVehicleTypes();
  }

  get answerInputsControls() {
    return (<FormArray>this.addPreferencesForm.get('answers')).controls;
  }
  addPreferenceAnswer() {
    if ((<FormArray>this.addPreferencesForm.get("answers")).length < 2) {
      const control = new FormControl('', Validators.required);
      (<FormArray>this.addPreferencesForm.get('answers')).push(control);
      this.answers = this.addPreferencesForm.get('answers').value.toString()
    }
    else {
      this.isMaxAnswer = true;
    }
  }

  removeAnswer(index) {
    (<FormArray>this.addPreferencesForm.get('answers')).removeAt(index);
    this.isMaxAnswer = false;
  }

  get t() { return this.cpf.questionDescription as FormArray; }
  get c() { return this.cpf.question as FormArray; }

  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: ['', Validators.required],
          description: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }
    if (this.c.length < number) {
      for (let i = this.c.length; i < number; i++) {
        this.c.push(this.formBuilder.group({
          languageId: ['', Validators.required],
          name: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.c.length; i >= number; i--) {
        this.c.removeAt(i);
      }
    }
  }

  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then(data => {
      if (localStorage.getItem("Theme") == Constant.BnhInterface) {
        this.vehicleTypes = data.responseObject;
      }
      else {
        this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
      }
    });
  }

  async getBrandData() {
    await this.GetAllBrand();
  }
  get cpf() {
    return this.addPreferencesForm.controls;
  }

  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.preference.mimeType = files[0].type;
    this.preference.image = files[0].name;
    this.preference.preferenceImage = "";
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const isValidFormate = this.imageService.validateImageFormat(this.preference.mimeType);
    if (isValidFormate) {
      reader.onload = (_readerEvent) => {
        me.imageBaseData = reader.result;
        this.preference.imageBinaryData = reader.result.toString().replace('data:' + this.preference.mimeType + ';base64,', '');
        this.preference.preferenceImage = me.imageBaseData;
      };
    }
    else {
      let imageErr = this.translate.instant("lblImageFormatError");
      this.toaster.error(imageErr)
    }
    reader.onerror = function (_error) {
      // This is intentional
    };
    this.spinner.hide();

  }
  async GetAllBrand() {
    await this.getAllBrandData.GetAllBrand().then(data => {
      this.brand = data.responseObject;
      for (let value of this.brand) {
        this.brandList.push(value)
      }
    })
  }

  addPreferences() {
    this.spinner.show();
    let currentUser = this.userService.currentUserValue.id;
    this.answers = this.addPreferencesForm.get('answers').value.toString()
    const viewModel = {
      ...this.addPreferencesForm.value,
      image: this.preference.image,
      mimeType: this.preference.mimeType,
      imageBinaryData: this.preference.imageBinaryData,
      createdBy: currentUser,
      answerInputs: this.answers,
      brandId: this.brandList.find(x => x.brandCode === this.addPreferencesForm.get('brand').value).id
    }
    const isValidFormat = this.imageService.validateImageFormat(this.preference.mimeType);
    if (isValidFormat) {
      this.preferenceService.addEditPreference(viewModel).then(res => {
        if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
          this.router.navigate(['preference']);
          let successMsg = this.translate.instant("lblPreferenceAdded");
          this.toaster.success(successMsg);
          this.activeModal.close({ success: true });
        }
        else if (res.responseCode === Enums.ErrorCodes.RentalCarAlreadyAdded) {
          this.spinner.hide();
          let errorErr = this.translate.instant("lblPreferenceExist");
          this.toaster.warning(errorErr);
        }
      });
    }
    else {
      let imageErr = this.translate.instant("lblImageFormatError");
      this.toaster.error(imageErr)
    }
    this.spinner.hide();
  }
  OnClose() {
    this.activeModal.close({success:false})
  }
}
